import {Button} from '@/components/ui/button';
import {useNavigate} from 'react-router-dom';

export default function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-primary-dark">
      <h1 className="text-6xl font-bold text-foreground">404</h1>
      <p className="mt-4 text-muted-foreground">Page not found</p>
      <Button className="mt-6" onClick={() => navigate('/')}>
        Go Home
      </Button>
    </div>
  );
}
